module.exports = __webpack_public_path__ + "static/img/totodi.f9e8f15.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/totodi.png
// module id = 301
// module chunks = 1